// Tema padrão do Reviter. Todas as cores que devem seguir o tema
// (incluindo em whitelabel) precisam estar aqui — o ThemeContext
// converte pra RGB e injeta como CSS var --color-*-rgb, que o
// tailwind.config lê via rgb(var(...) / <alpha-value>).
//
// Contraste auditado (WCAG AA ≥4.5:1 pra texto pequeno):
//   - text (#0F172A)       sobre bg (#FFFFFF)           = 17.9 : 1 (AAA)
//   - textSecondary (#4B5563) sobre bg                 =  7.6 : 1 (AAA)
//   - textSecondary        sobre surface (#F9FAFB)     =  7.3 : 1 (AAA)
//   - white                sobre primary (#1E5AA8)     =  7.2 : 1 (AAA)
//   - white                sobre secondary (#6D28D9)   =  7.6 : 1 (AAA)
//   - border (#D1D5DB)     sobre bg                    =  1.7 : 1  (decorativo, ok)
export const defaultTheme = {
  primary: '#1E5AA8',         // azul da marca um degrau mais escuro — contraste AAA com branco
  primaryDark: '#163F76',     // hover/ênfase
  primaryLight: '#2ab4da',    // decorativo (backgrounds, ilustrações)
  secondary: '#6D28D9',       // roxo escuro — contraste AAA com branco
  secondaryDark: '#5B21B6',
  secondaryLight: '#A78BFA',  // decorativo
  accent: '#059669',          // verde escuro — contraste AA com branco
  bg: '#FFFFFF',
  surface: '#F9FAFB',
  surfaceHover: '#F3F4F6',
  text: '#0F172A',            // quase preto (slate-900)
  textSecondary: '#4B5563',   // cinza escuro (gray-600) — contraste AAA em bg/surface
  border: '#D1D5DB',          // cinza médio (gray-300) — mais visível que #E5E7EB
  success: '#059669',
  warning: '#D97706',
  error: '#DC2626',
  info: '#2563EB',
};

// Presets pra desenvolvimento e demo. Em produção, cada loja tem seu
// próprio theme persistido em `stores.theme` (jsonb no back).
export const supplierThemes = {
  supplier1: {
    primary: '#EF4444',
    primaryDark: '#DC2626',
    primaryLight: '#F87171',
    secondary: '#F59E0B',
    secondaryDark: '#D97706',
    secondaryLight: '#FBBF24',
    accent: '#10B981',
    bg: '#FFFFFF',
    surface: '#FEF2F2',
    surfaceHover: '#FEE2E2',
    text: '#111827',
    textSecondary: '#6B7280',
    border: '#FECACA',
    success: '#10B981',
    warning: '#F59E0B',
    error: '#DC2626',
    info: '#3B82F6',
  },
  supplier2: {
    primary: '#8B5CF6',
    primaryDark: '#7C3AED',
    primaryLight: '#A78BFA',
    secondary: '#EC4899',
    secondaryDark: '#DB2777',
    secondaryLight: '#F472B6',
    accent: '#10B981',
    bg: '#FFFFFF',
    surface: '#FAF5FF',
    surfaceHover: '#F3E8FF',
    text: '#111827',
    textSecondary: '#6B7280',
    border: '#E9D5FF',
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
  },
  supplier3: {
    primary: '#06B6D4',
    primaryDark: '#0891B2',
    primaryLight: '#22D3EE',
    secondary: '#3B82F6',
    secondaryDark: '#2563EB',
    secondaryLight: '#60A5FA',
    accent: '#10B981',
    bg: '#FFFFFF',
    surface: '#F0FDFA',
    surfaceHover: '#CCFBF1',
    text: '#111827',
    textSecondary: '#6B7280',
    border: '#A5F3FC',
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
  },
};

// Mapeamento theme key → CSS var name. Centralizado pra ThemeContext
// e tailwind.config consumirem a mesma fonte de verdade.
export const themeKeyToCssVar = {
  primary: 'primary',
  primaryDark: 'primary-dark',
  primaryLight: 'primary-light',
  secondary: 'secondary',
  secondaryDark: 'secondary-dark',
  secondaryLight: 'secondary-light',
  accent: 'accent',
  bg: 'bg',
  surface: 'surface',
  surfaceHover: 'surface-hover',
  text: 'text',
  textSecondary: 'text-secondary',
  border: 'border',
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
};
